import backend, { csrf } from "@/src/lib/axios/backend";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ITotal {
    users: number;
    earnings: number;
    transactions: number;
    today_engagment: ITodayEngagement;
}

interface ITodayEngagement {
    total_views: number;
    total_users: number;
    total_amount: number;
}

interface ILoading {
    total: boolean;
}

interface IInitialState {
    total: ITotal;
    loading: ILoading;
}

const initialState: IInitialState = {
    total: {
        users: 0,
        earnings: 0,
        transactions: 0,
        today_engagment: {
            total_views: 0,
            total_users: 0,
            total_amount: 0
        } 
    },
    loading: {
        total: false,
    }
}


export const getTotals = createAsyncThunk("analytic/totals", async () => {
    try {
        await csrf();
        const res = await backend.get("/api/analytics/totals");
        return res.data;
    } catch (error) {
        throw error;
    }
})


const analyticSlice = createSlice({
    name: "analytic",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTotals.pending, (state) => {
            state.loading.total = true;
        }).addCase(getTotals.fulfilled, (state, action:PayloadAction<ITotal>) => {
            state.total = action.payload;
            state.loading.total = false;
        }).addCase(getTotals.rejected, (state, action) => {
            state.loading.total = false;
        })
    }
});

export const AnalyticAction = analyticSlice.actions;
export default analyticSlice;